import React from 'react';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useGetCommunicationAPI } from '@src/hooks/useGetCommunicationAPI';
import { useSelector } from 'react-redux';

const SubmitButton = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '15px',
});

export const ConfirmationModal = ({ isOpen, isClosed, title }) => {
  const [, getCommunicationAPI] = useGetCommunicationAPI();
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });

  const modalClose = () => {
    getCommunicationAPI({ allMessages: true, userInfo: { data: userInfo } });
    isClosed(false);
  };

  return (
    <ModalDialog
      header={title}
      isOpen={isOpen}
      onClose={() => {
        return modalClose();
      }}
      css={{
        'abyss-modal-base-header-container': {
          color: '#002677',
          fontSize: '28.83px',
        },
        'abyss-modal-base-header': {
          fontFamily: 'AbyssUHCSerif !important',
          fontSize: '26px !important',
          padding: '8px 16px',
        },
      }}
    >
      <SubmitButton>
        <Button
          id="submitButton"
          fontSize="15px"
          size="$md"
          onClick={() => {
            return modalClose();
          }}
        >
          OK
        </Button>
      </SubmitButton>
    </ModalDialog>
  );
};
ConfirmationModal.propTypes = {
  isClosed: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
